import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';

export const clientsRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'clients' },
    loadComponent: () => import('./clients/clients.page').then((m) => m.ClientsPage),
    path: '',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'client-details' },
    loadComponent: () => import('./client-details/client-details.page').then((m) => m.ClientDetailsPage),
    path: ':clientId',
  },
];
